import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  UpdateIssueIssueTypeInput,
  updateIssueIssueTypeSharedMutation,
  updateIssueIssueTypeSharedMutation$data,
} from './__generated__/updateIssueIssueTypeSharedMutation.graphql'

export function commitUpdateIssueIssueTypeMutation({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: UpdateIssueIssueTypeInput
  onError?: (error: Error) => void
  onCompleted?: (response: updateIssueIssueTypeSharedMutation$data) => void
}) {
  return commitMutation<updateIssueIssueTypeSharedMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation updateIssueIssueTypeSharedMutation($input: UpdateIssueIssueTypeInput!) @raw_response_type {
        updateIssueIssueType(input: $input) {
          issue {
            issueType {
              id
              name
              isEnabled
              description
              color
            }
          }
        }
      }
    `,
    variables: {
      input,
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
